import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-valores-mcc',
  templateUrl: './valores-mcc.component.html',
  styleUrls: ['./valores-mcc.component.scss']
})
export class ValoresMCCComponent {

  urlDocServTarifas = environment.redirections.urlDocServTarifas;
  precioMastercard: number = 0;
  precioVisa: number = 0;
  precioAmex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ValoresMCCComponent>,
    protected productoServiceVM: vmProductosService,
    protected dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.productoServiceVM.obtenerValoresMCC().subscribe((resp: any) => {
      resp.data.forEach((item: { name: any; value: any; }) => {
        switch (item.name) {
          case "PrecioMastercard":
            this.precioMastercard = Number(item.value);
            break;
          case "PrecioVisa":
            this.precioVisa = Number(item.value);
            break;
          case "PrecioAmex":
            this.precioAmex = Number(item.value);
            break;
          default:
            break;
        }
      });
    }, (error) => {
      console.error(error);
      this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, reintente.');
    });
  }

  onCloseClick(): void {
    this.dialogRef.close({
      action: 'CLOSE'
    });
  }

}
